import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useForm } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { User } from '@/types';
    import { computed } from 'vue';
    import ActivateButton from '@/components/ActivateButton.vue';
    import DeactivateButton from '@/components/DeactivateButton.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        user: User;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleActivationUser',
  props: {
    user: {}
  },
  emits: ['deleted', 'error'],
  setup(__props: any, { emit: __emit }) {

    const queryClient = useQueryClient();

    const emit = __emit;

    const { t } = useI18n();

    const props = __props;

    const form = useForm({});

    const isActive = computed(() => {
        return props.user.deleted_at ? false : true;
    });

    const type = computed(() => {
        return isActive.value ? 'deactivate' : 'activate';
    });

    const path = computed(() => {
        return isActive.value ? 'v2.users.deactivate' : 'v2.users.activate';
    });

    const action = () => {
        form.post(route(path.value, props.user.id), {
            preserveScroll: true,
            onSuccess: () => {
                updateTable();
                toast.success(t(`users.${type.value}.success`));
                emit('deleted');
            },
            onError: (error) => {
                toast.error(t('forms.general.error'));
                emit('error', error);
            },
        });
    };

    const updateTable = () => {
        queryClient.invalidateQueries({ queryKey: [QueryKey.USERS] });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          (!isActive.value)
            ? (_openBlock(), _createBlock(ActivateButton, {
                key: 0,
                class: "mr-auto"
              }))
            : (_openBlock(), _createBlock(DeactivateButton, {
                key: 1,
                class: "mr-auto"
              }))
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.${type.value}.title`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.${type.value}.content`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.${type.value}.no`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                onClick: action,
                variant: isActive.value ? 'destructive' : 'default'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`users.${type.value}.yes`)), 1)
                ]),
                _: 1
              }, 8, ["variant"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})